import Base from "../base";

/** 集計AIサマリ設定 */
export interface BiaggregateAisummaryConfiguration extends Base {
  /** ID */
  id: number;
  /** プロンプトテンプレートID */
  biaggregate_aisummary_prompt_template_id: number;
}

/** 集計AIサマリ設定初期値 */
export const DefaultBiaggregateAisummaryConfiguration =
  (): BiaggregateAisummaryConfiguration => ({
    id: 0,
    biaggregate_aisummary_prompt_template_id: 0,
    created_at: "",
    updated_at: "",
    deleted_at: "",
  });

/** 集計AIサマリプロンプトテンプレート_LLM設定 */
export interface BiaggregateAisummaryLlmConfig {
  /** LLM種類 1:OpenAI 2:Google 3:Claude */
  llm_type: number;
  /** モデル名 */
  model: string;
  /** temperature(0.0〜2.0) */
  temperature: string;
  /** top_p(0.0〜1.0) */
  top_p: string;
  /** frequency_penalty(-2.0〜2.0) */
  frequency_penalty: string;
  /** presence_penalty(-2.0〜2.0) */
  presence_penalty: string;
}

export const DefaultBiaggregateAisummaryLlmConfig =
  (): BiaggregateAisummaryLlmConfig => ({
    llm_type: 0,
    model: "",
    temperature: "0.5",
    top_p: "1.0",
    frequency_penalty: "0.0",
    presence_penalty: "0.0",
  });

/** 集計AIサマリプロンプトテンプレート */
export interface BiaggregateAisummaryPromptTemplate extends Base {
  /** ID */
  id: number;
  /** テンプレート名 */
  name: string;
  /** コメント */
  comment: string;
  /** LLM設定 */
  llm_config: BiaggregateAisummaryLlmConfig;
  /** 最終更新管理者ID */
  editor_admin_id: number;
  /** プロンプトテンプレートブロック */
  blocks: BiaggregateAisummaryPromptTemplateBlock[];
}

export const DefaultBiaggregateAisummaryPromptTemplate =
  (): BiaggregateAisummaryPromptTemplate => ({
    id: 0,
    name: "",
    comment: "",
    llm_config: DefaultBiaggregateAisummaryLlmConfig(),
    editor_admin_id: 0,
    blocks: [],
    created_at: "",
    updated_at: "",
    deleted_at: "",
  });

/** 集計AIサマリプロンプトテンプレートブロック */
export interface BiaggregateAisummaryPromptTemplateBlock extends Base {
  /** ID */
  id: number;
  /** プロンプトテンプレートID */
  biaggregate_aisummary_prompt_template_id: number;
  /** ブロックタイプ 1:システムプロンプト 2:ユーザープロンプト 3:動的プロンプト */
  block_type: number;
  /** ブロックテキスト */
  block_text: string;
}

export const DefaultBiaggregateAisummaryPromptTemplateBlock =
  (): BiaggregateAisummaryPromptTemplateBlock => ({
    id: 0,
    biaggregate_aisummary_prompt_template_id: 0,
    block_type: 2,
    block_text: "",
    created_at: "",
    updated_at: "",
    deleted_at: "",
  });
